import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { useNavigate } from 'react-router-dom';

import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import 'mapbox-gl/dist/mapbox-gl.css';
mapboxgl.accessToken = 'pk.eyJ1IjoiaGFycnltb250YW5vIiwiYSI6ImNqZWY0bDcyaTFkcGYzM28ydHFpaDJxaWcifQ.Wf7aNVePBRWZ9fMy_I81qw';
import { center, points } from "@turf/turf";
import { districts, district_outliners } from 'helper/group_districts';
import { group_outliners } from 'helper/group_outliners';
import { getUserAccessLevel } from 'helper/user';
import { useSoftUIController } from 'context';

function getMapPolygons(group) {

  var polygon = {
    'type': 'FeatureCollection',
    'features': group.geojson
  }

  polygon.features.forEach(function (feature) {
    feature.properties = {
      group_id: group.group_id,
      name: group.name,
      // uuids: group.uuids
    };
  })

  return polygon;
}

function ExploringMap({ map, mapPadding, extraPadding, user_role = "viewer", groups_data, sidebarOpen, menuToggled, setMenuToggled, setGroupPreviewID, deviceStyle = "desktop" }) {

  var popups = [];

  for (var d_index in districts) {
    popups.push(new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false
    }));
  }

  const navigate = useNavigate();
  var set_padding = 100;

  const handleGroupDblClick = (e) => {
    navigate("/groups/" + e.features[0].properties.group_id);
  }

  const handleGroupClick = (e) => {
    setGroupPreviewID(e.features[0].properties.group_id);
    navigate("/explore/groups/" + e.features[0].properties.group_id);
  }

  const handleMapClick = (e) => {
    setGroupPreviewID(0);
  }

  const handleMouseEnter = (e) => {
    map.current.getCanvas().style.cursor = 'pointer';
  }

  const handleMouseLeave = (e) => {
    map.current.getCanvas().style.cursor = '';
  }

  const handleDistrictEnter = (e) => {
    // console.log('handleDistrictEnter');
    // console.log(e.features[0].properties.district_id)
    map.current.setPaintProperty('geojson-district-' + e.features[0].properties.district_id, 'fill-opacity', 0.2);
    map.current.setPaintProperty('geojson-district-border-' + e.features[0].properties.district_id, 'line-opacity', 1);

    var new_coords = [];
    for (var coords of e.features[0].geometry.coordinates[0]) {
      new_coords.push([Number(coords[0]), Number(coords[1])]);
    }

    var features = points(new_coords);
    var district_center = center(features).geometry.coordinates;
    district_center = [Number(district_center[0]), Number(district_center[1])]

    const description = e.features[0].properties.district_name;

    // popups[e.features[0].properties.district_id].setLngLat(district_center).setHTML(description).addTo(map.current);
  }

  const handleDistrictLeave0 = (e) => {
    // console.log('handleDistrictLeave0');
    map.current.setPaintProperty('geojson-district-0', 'fill-opacity', 0);
    map.current.setPaintProperty('geojson-district-border-0', 'line-opacity', 0);
    // popups[0].remove();
  }

  const handleDistrictLeave1 = (e) => {
    // console.log('handleDistrictLeave1');
    map.current.setPaintProperty('geojson-district-1', 'fill-opacity', 0);
    map.current.setPaintProperty('geojson-district-border-1', 'line-opacity', 0);
    // popups[1].remove();
  }

  const handleDistrictLeave2 = (e) => {
    // console.log('handleDistrictLeave2');
    map.current.setPaintProperty('geojson-district-2', 'fill-opacity', 0);
    map.current.setPaintProperty('geojson-district-border-2', 'line-opacity', 0);
    // popups[2].remove();
  }

  const handleDistrictLeave3 = (e) => {
    // console.log('handleDistrictLeave3');
    map.current.setPaintProperty('geojson-district-3', 'fill-opacity', 0);
    map.current.setPaintProperty('geojson-district-border-3', 'line-opacity', 0);
    // popups[3].remove();
  }

  useEffect(() => {
    var bounds = new mapboxgl.LngLatBounds();

    groups_data.forEach(function (group) {
      group.geojson.forEach(function (feature) {
        feature.geometry.coordinates.forEach(function (coords) {
          coords.forEach(function (coord) {
            bounds.extend(coord);
          })
        })
      })
    });



    if (!sidebarOpen) {
      if (extraPadding) {
        var map_padding = [0, 250];
      }
      else {
        var map_padding = [0, 0];
      }
    }
    else {
      if (extraPadding) {
        var map_padding = [600, 250];
      }
      else {
        var map_padding = [600, 0];
      }
    }

    if (map.current) {
      if (menuToggled) {
        if (deviceStyle == 'mobile') {
          var padding = {
            top: set_padding / 2,
            bottom: set_padding / 2,
            right: set_padding / 2,
            left: set_padding / 2,
          }
        }
        else {
          if (extraPadding) {
            var padding = {
              top: set_padding,
              bottom: map_padding[1] + (1.5 * set_padding),
              right: set_padding,
              left: map_padding[0] + set_padding,
            }
          }
          else {
            var padding = {
              top: set_padding,
              bottom: map_padding[1] + set_padding,
              right: set_padding,
              left: map_padding[0] + set_padding,
            }
          }
        }

        map.current.fitBounds(bounds, { padding: padding });
        setMenuToggled(false);
      }
      else {
        map.current.easeTo({
          padding: {
            left: map_padding[0],
            bottom: map_padding[1]
          },
          duration: 500
        });
      }
    }

  }, [sidebarOpen]);

  useEffect(() => {  //mount
    if (map.current) {

      // add district polygons
      for (var d_index in districts) {

        var existing_district_source = map.current.getSource('geojson-district-' + d_index);
        var existing_district_outliner_source = map.current.getSource('geojson-district-outliner-' + d_index);

        var existing_district_layer = map.current.getLayer('geojson-district-' + d_index);
        var existing_district_outliner_layer = map.current.getLayer('geojson-district-outliner-' + d_index);

        if (!existing_district_source) {
          map.current.addSource('geojson-district-' + d_index, {
            type: 'geojson',
            data: {
              'type': 'FeatureCollection',
              'features': districts[d_index]
            }
          });

          map.current.addSource('geojson-district-outliner-' + d_index, {
            type: 'geojson',
            data: {
              'type': 'FeatureCollection',
              'features': district_outliners[d_index]
            }
          });

        }

        if (!existing_district_layer) {
          map.current.addLayer({
            id: 'geojson-district-' + d_index,
            type: 'fill',
            source: 'geojson-district-' + d_index,
            paint: {
              "fill-opacity": 0,
              "fill-color": 'grey',
              'fill-opacity-transition': { duration: 500 }
            }
          }).addLayer({
            id: 'geojson-district-border-' + d_index,
            type: 'line',
            source: 'geojson-district-' + d_index,
            paint: {
              "line-color": 'grey',
              "line-width": 2,
              'line-opacity': 0,
              'line-opacity-transition': { duration: 500 }
            }
          });

          map.current.addLayer({
            id: 'geojson-district-outliner-' + d_index,
            type: 'fill',
            source: 'geojson-district-outliner-' + d_index,
            paint: {
              "fill-opacity": 0,
              "fill-color": 'grey',
            }
          }).addLayer({
            id: 'geojson-district-outliner-border-' + d_index,
            type: 'line',
            source: 'geojson-district-outliner-' + d_index,
            paint: {
              "line-color": 'grey',
              "line-width": 1,
              'line-opacity': 0
            }
          });

          map.current.on('mouseenter', 'geojson-district-outliner-' + d_index, handleDistrictEnter);
        }
      }

      map.current.on('mouseleave', 'geojson-district-outliner-0', handleDistrictLeave0);
      map.current.on('mouseleave', 'geojson-district-outliner-1', handleDistrictLeave1);
      map.current.on('mouseleave', 'geojson-district-outliner-2', handleDistrictLeave2);
      map.current.on('mouseleave', 'geojson-district-outliner-3', handleDistrictLeave3);

      group_outliners.forEach(function (group) {
        if (typeof group.parent_id == 'undefined') {
          var polygons = getMapPolygons(group);
          var existing_layer = map.current.getLayer('geojson-outliner-' + group.group_id);
          var existing_source = map.current.getSource('geojson-outliner-' + group.group_id);

          if (!existing_source) {
            map.current.addSource('geojson-outliner-' + group.group_id, {
              type: 'geojson',
              data: polygons
            });
          }
          if (!existing_layer) {
            map.current.addLayer({
              id: 'geojson-outliner-' + group.group_id,
              type: 'fill',
              source: 'geojson-outliner-' + group.group_id,
              paint: {
                "fill-color": "black",
                "fill-opacity": 0,
              }
            }).addLayer({
              id: 'geojson-outliner-border-' + group.group_id,
              type: 'line',
              source: 'geojson-outliner-' + group.group_id,
              paint: {
                'line-color': 'black',
                'line-opacity': 0
              }
            });

            // map.current.on('dblclick', 'geojson-' + group.group_id, handleGroupDblClick);
            map.current.on('click', 'geojson-outliner-' + group.group_id, handleGroupClick);
            map.current.on('mouseenter', 'geojson-outliner-' + group.group_id, handleMouseEnter);
            map.current.on('mouseleave', 'geojson-outliner-' + group.group_id, handleMouseLeave);
            map.current.on('click', handleMapClick);
          }
        }
      });

      groups_data.forEach(function (group) {
        var polygons = getMapPolygons(group);
        var existing_layer = map.current.getLayer('geojson-' + group.group_id);
        var existing_source = map.current.getSource('geojson-' + group.group_id);
        // console.log(existing_layer)
        // console.log(existing_source)

        if (!group.all_updated) {
          var polygon_colour = "#ff667c";
        }
        else if (group.devices_monitored > 0 && getUserAccessLevel(user_role, 'technician')) {
          var polygon_colour = "#edaa00";
        }
        else {
          var polygon_colour = "#58ba2d";
        }

        if (!existing_source) {
          map.current.addSource('geojson-' + group.group_id, {
            type: 'geojson',
            data: polygons
          });
        }
        if (!existing_layer) {
          map.current.addLayer({
            id: 'geojson-' + group.group_id,
            type: 'fill',
            source: 'geojson-' + group.group_id,
            paint: {
              "fill-opacity": 0.2,
              "fill-color": polygon_colour
            }
          }).addLayer({
            id: 'geojson-border-' + group.group_id,
            type: 'line',
            source: 'geojson-' + group.group_id,
            paint: {
              "line-color": polygon_colour,
              "line-width": 2
            }
          });

          // map.current.on('dblclick', 'geojson-' + group.group_id, handleGroupDblClick);
          map.current.on('click', 'geojson-' + group.group_id, handleGroupClick);
          // map.current.on('mouseenter', 'geojson-' + group.group_id, handleMouseEnter);
          // map.current.on('mouseleave', 'geojson-' + group.group_id, handleMouseLeave);
          // map.current.on('click', handleMapClick);
        }
      });
    }
  }, []);

  useEffect(() => () => { //unmount
    // console.log(groups_data)

    districts.forEach(function (row, d_index) {
      var existing_district_layer = map.current.getLayer('geojson-district-' + d_index);
      var existing_district_outliner_layer = map.current.getLayer('geojson-district-outliner-' + d_index);

      if (existing_district_layer) {
        map.current.removeLayer('geojson-district-' + d_index);
        map.current.removeLayer('geojson-district-border-' + d_index);
        map.current.removeSource('geojson-district-' + d_index);
      }

      if (existing_district_outliner_layer) {
        map.current.removeLayer('geojson-district-outliner-' + d_index);
        map.current.removeLayer('geojson-district-outliner-border-' + d_index);
        map.current.removeSource('geojson-district-outliner-' + d_index);
      }

      map.current.off('mouseenter', 'geojson-district-outliner-' + d_index, handleDistrictEnter);
      popups[d_index].remove();
    })

    map.current.off('mouseleave', 'geojson-district-outliner-0', handleDistrictLeave0);
    map.current.off('mouseleave', 'geojson-district-outliner-1', handleDistrictLeave1);
    map.current.off('mouseleave', 'geojson-district-outliner-2', handleDistrictLeave2);
    map.current.off('mouseleave', 'geojson-district-outliner-3', handleDistrictLeave3);

    group_outliners.forEach(function (group) {
      var existing_layer = map.current.getLayer('geojson-outliner-' + group.group_id);
      if (existing_layer) {
        // map.current.off('dblclick', 'geojson-outliner-' + group.group_id, handleGroupDblClick);
        map.current.off('click', 'geojson-outliner-' + group.group_id, handleGroupClick);
        map.current.off('mouseenter', 'geojson-outliner-' + group.group_id, handleMouseEnter);
        map.current.off('mouseleave', 'geojson-outliner-' + group.group_id, handleMouseLeave);

        map.current.removeLayer('geojson-outliner-' + group.group_id);
        map.current.removeLayer('geojson-outliner-border-' + group.group_id);
        map.current.removeSource('geojson-outliner-' + group.group_id);
      }
    });

    groups_data.forEach(function (group) {
      var existing_layer = map.current.getLayer('geojson-' + group.group_id);
      if (existing_layer) {
        // map.current.off('dblclick', 'geojson-' + group.group_id, handleGroupDblClick);
        map.current.off('click', 'geojson-' + group.group_id, handleGroupClick);
        map.current.off('mouseenter', 'geojson-' + group.group_id, handleMouseEnter);
        map.current.off('mouseleave', 'geojson-' + group.group_id, handleMouseLeave);
        map.current.off('click', handleMapClick);

        map.current.removeLayer('geojson-' + group.group_id);
        map.current.removeLayer('geojson-border-' + group.group_id);
        map.current.removeSource('geojson-' + group.group_id);
      }
    })

  }, []);
}

ExploringMap.propTypes = {
  map: PropTypes.object,
  mapPadding: PropTypes.array,
  extraPadding: PropTypes.bool,
  user_role: PropTypes.string,
  groups_data: PropTypes.array,
  bounds: PropTypes.object,
  sidebarOpen: PropTypes.bool,
  menuToggled: PropTypes.bool,
  setMenuToggled: PropTypes.func,
  setGroupPreviewID: PropTypes.func,
  deviceStyle: PropTypes.string,
};

export default ExploringMap;